import { render, staticRenderFns } from "./RatingDistributionChart.vue?vue&type=template&id=731eca73&scoped=true&"
import script from "./RatingDistributionChart.vue?vue&type=script&lang=js&"
export * from "./RatingDistributionChart.vue?vue&type=script&lang=js&"
import style0 from "./RatingDistributionChart.vue?vue&type=style&index=0&id=731eca73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731eca73",
  null
  
)

/* custom blocks */
import block0 from "./RatingDistributionChart.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('731eca73')) {
      api.createRecord('731eca73', component.options)
    } else {
      api.reload('731eca73', component.options)
    }
    module.hot.accept("./RatingDistributionChart.vue?vue&type=template&id=731eca73&scoped=true&", function () {
      api.rerender('731eca73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/survey-analysis/charts/RatingDistributionChart.vue"
export default component.exports